export var ProductSurfacePathType;
(function (ProductSurfacePathType) {
    ProductSurfacePathType["BLEED"] = "BLEED";
    ProductSurfacePathType["TRIM"] = "TRIM";
    ProductSurfacePathType["SAFE"] = "SAFE";
    ProductSurfacePathType["CUT"] = "CUT";
})(ProductSurfacePathType || (ProductSurfacePathType = {}));
//# sourceMappingURL=ProductSurface.js.map